import type { CategoryItem } from "@/types/comic";

export const categories: CategoryItem[] = [
  { key: "校园", name: "校园青春", icon: "ri-graduation-cap-line", desc: "教室里悄悄萌芽的少女心事" },
  { key: "奇幻", name: "奇幻魔法", icon: "ri-magic-line", desc: "剑与魔法世界中的双向奔赴" },
  { key: "恋爱", name: "恋爱心动", icon: "ri-heart-3-line", desc: "从心动到相守的浪漫故事" },
  { key: "都市", name: "都市日常", icon: "ri-building-2-line", desc: "都市灯火下的温柔相遇" },
  { key: "悬疑", name: "悬疑推理", icon: "ri-eye-line", desc: "谜团背后藏着怎样的真心" },
  { key: "古风", name: "古风宫廷", icon: "ri-moon-line", desc: "深宫重楼里的隐秘情愫" },
  { key: "治愈", name: "治愈温暖", icon: "ri-sun-line", desc: "被温柔包裹的每个清晨" },
  { key: "科幻", name: "科幻未来", icon: "ri-planet-line", desc: "穿越星海的命中注定" },
];

export const genreOptions = ["校园", "奇幻", "恋爱", "都市", "悬疑", "古风", "治愈", "科幻", "动作", "美食", "音乐", "日常"];

export const styleTags = ["甜宠", "虐心", "慢热", "双向奔赴", "欢喜冤家", "破镜重圆", "暗恋", "强强", "治愈系"];

export const statusOptions = ["全部", "连载中", "完结"];

export const sortOptions = [
  { key: "updated", label: "最近更新" },
  { key: "hot", label: "人气最高" },
  { key: "rating", label: "评分最高" },
];